<div class="drop-container">
  <div>
    <div class="drop-header">
      <span class="title">
        {{'cv_upload'|translate}}
      </span>
      <mat-icon class="close-icon" svgIcon="close" (click)="close()"></mat-icon>
    </div>
    <div class="drop-body">
      <ngx-dropzone class="dropzone" (change)="onSelect($event)" accept=".pdf,.docx" [multiple]="false">
        <ngx-dropzone-label>{{ (parsing ? 'cv_parsing_progress' : 'cv_select_file' ) | translate }}</ngx-dropzone-label>
      </ngx-dropzone>
      <ngx-dropzone-preview class="dropzone-preview" *ngIf="file" [removable]="true" (removed)="onRemove(file)">
        <ngx-dropzone-label class="drop-label">
          <img *ngIf="file.type !== 'application/pdf'" class="file-icon" src="/assets/images/word.png">
          <img *ngIf="file.type === 'application/pdf'" class="file-icon" src="/assets/images/pdf.png">
          <b>{{ file.name }}</b>
        </ngx-dropzone-label>
      </ngx-dropzone-preview>
      <div *ngIf="parsing" class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
  <div class="action-block">
    <button *ngIf="file" class="parse-button" color="primary" mat-button (click)="parseFile()">Parse file</button>
  </div>
</div>
